module.exports = __webpack_public_path__ + "img/peru-posible.1122c8ca.png";